import { render, staticRenderFns } from "./TenantResources.vue?vue&type=template&id=4ce0ee64&scoped=true&"
import script from "./TenantResources.vue?vue&type=script&lang=ts&"
export * from "./TenantResources.vue?vue&type=script&lang=ts&"
import style0 from "./TenantResources.vue?vue&type=style&index=0&id=4ce0ee64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce0ee64",
  null
  
)

export default component.exports